import { plural } from '@ipfabric/frontend-shared-assets/utils/plural';
import { MenuItem } from '@ipfabric/ui-components/MenuItem/MenuItem';
import { isFeatureFlagEnabled } from '@ipfabric/ui-components/utils/featureFlags';

type Props = {
  definitions: { enabled: boolean }[];
  selected: boolean;
  onClick: () => void;
};

/** The Custom Discovery Data menu entry, present only with its feature flag. */
export const customDiscoveryDataMenuItems = ({
  definitions,
  selected,
  onClick,
}: Props) => {
  if (!isFeatureFlagEnabled('ENABLE_CUSTOM_DISCOVERY_DATA')) {
    return [];
  }
  const enabledCount = definitions.filter((d) => d.enabled).length;
  return [
    <MenuItem
      label='Custom Discovery Data'
      key='customDiscoveryData'
      description={`${enabledCount} of ${definitions.length} ${plural(definitions.length, 'definition')} enabled`}
      selected={selected}
      onClick={onClick}
    />,
  ];
};
